import flag_AD from '../svgs/ad.svg'
import flag_AE from '../svgs/ae.svg'
import flag_AF from '../svgs/af.svg'
import flag_AG from '../svgs/ag.svg'
import flag_AI from '../svgs/ai.svg'
import flag_AL from '../svgs/al.svg'
import flag_AM from '../svgs/am.svg'
import flag_AN from '../svgs/an.svg'
import flag_AO from '../svgs/ao.svg'
import flag_AQ from '../svgs/aq.svg'
import flag_AR from '../svgs/ar.svg'
import flag_AS from '../svgs/as.svg'
import flag_AT from '../svgs/at.svg'
import flag_AU from '../svgs/au.svg'
import flag_AW from '../svgs/aw.svg'
import flag_AX from '../svgs/ax.svg'
import flag_AZ from '../svgs/az.svg'
import flag_BA from '../svgs/ba.svg'
import flag_BB from '../svgs/bb.svg'
import flag_BD from '../svgs/bd.svg'
import flag_BE from '../svgs/be.svg'
import flag_BF from '../svgs/bf.svg'
import flag_BG from '../svgs/bg.svg'
import flag_BH from '../svgs/bh.svg'
import flag_BI from '../svgs/bi.svg'
import flag_BJ from '../svgs/bj.svg'
import flag_BL from '../svgs/bl.svg'
import flag_BM from '../svgs/bm.svg'
import flag_BN from '../svgs/bn.svg'
import flag_BO from '../svgs/bo.svg'
import flag_BQ from '../svgs/bq.svg'
import flag_BR from '../svgs/br.svg'
import flag_BS from '../svgs/bs.svg'
import flag_BT from '../svgs/bt.svg'
import flag_BV from '../svgs/bv.svg'
import flag_BW from '../svgs/bw.svg'
import flag_BY from '../svgs/by.svg'
import flag_BZ from '../svgs/bz.svg'
import flag_CA from '../svgs/ca.svg'
import flag_CC from '../svgs/cc.svg'
import flag_CD from '../svgs/cd.svg'
import flag_CF from '../svgs/cf.svg'
import flag_CG from '../svgs/cg.svg'
import flag_CH from '../svgs/ch.svg'
import flag_CI from '../svgs/ci.svg'
import flag_CK from '../svgs/ck.svg'
import flag_CL from '../svgs/cl.svg'
import flag_CM from '../svgs/cm.svg'
import flag_CN from '../svgs/cn.svg'
import flag_CO from '../svgs/co.svg'
import flag_CR from '../svgs/cr.svg'
import flag_CU from '../svgs/cu.svg'
import flag_CV from '../svgs/cv.svg'
import flag_CW from '../svgs/cw.svg'
import flag_CX from '../svgs/cx.svg'
import flag_CY from '../svgs/cy.svg'
import flag_CZ from '../svgs/cz.svg'
import flag_DE from '../svgs/de.svg'
import flag_DJ from '../svgs/dj.svg'
import flag_DK from '../svgs/dk.svg'
import flag_DM from '../svgs/dm.svg'
import flag_DO from '../svgs/do.svg'
import flag_DZ from '../svgs/dz.svg'
import flag_EC from '../svgs/ec.svg'
import flag_EE from '../svgs/ee.svg'
import flag_EG from '../svgs/eg.svg'
import flag_EH from '../svgs/eh.svg'
import flag_ER from '../svgs/er.svg'
import flag_ES from '../svgs/es.svg'
import flag_ET from '../svgs/et.svg'
import flag_EU from '../svgs/eu.svg'
import flag_FI from '../svgs/fi.svg'
import flag_FJ from '../svgs/fj.svg'
import flag_FK from '../svgs/fk.svg'
import flag_FM from '../svgs/fm.svg'
import flag_FO from '../svgs/fo.svg'
import flag_FR from '../svgs/fr.svg'
import flag_GA from '../svgs/ga.svg'
import flag_GB_ENG from '../svgs/gb-eng.svg'
import flag_GB_NIR from '../svgs/gb-nir.svg'
import flag_GB_SCT from '../svgs/gb-sct.svg'
import flag_GB_WLS from '../svgs/gb-wls.svg'
import flag_GB from '../svgs/gb.svg'
import flag_GD from '../svgs/gd.svg'
import flag_GE from '../svgs/ge.svg'
import flag_GF from '../svgs/gf.svg'
import flag_GG from '../svgs/gg.svg'
import flag_GH from '../svgs/gh.svg'
import flag_GI from '../svgs/gi.svg'
import flag_GL from '../svgs/gl.svg'
import flag_GM from '../svgs/gm.svg'
import flag_GN from '../svgs/gn.svg'
import flag_GP from '../svgs/gp.svg'
import flag_GQ from '../svgs/gq.svg'
import flag_GR from '../svgs/gr.svg'
import flag_GS from '../svgs/gs.svg'
import flag_GT from '../svgs/gt.svg'
import flag_GU from '../svgs/gu.svg'
import flag_GW from '../svgs/gw.svg'
import flag_GY from '../svgs/gy.svg'
import flag_HK from '../svgs/hk.svg'
import flag_HM from '../svgs/hm.svg'
import flag_HN from '../svgs/hn.svg'
import flag_HR from '../svgs/hr.svg'
import flag_HT from '../svgs/ht.svg'
import flag_HU from '../svgs/hu.svg'
import flag_ID from '../svgs/id.svg'
import flag_IE from '../svgs/ie.svg'
import flag_IL from '../svgs/il.svg'
import flag_IM from '../svgs/im.svg'
import flag_IN from '../svgs/in.svg'
import flag_IO from '../svgs/io.svg'
import flag_IQ from '../svgs/iq.svg'
import flag_IR from '../svgs/ir.svg'
import flag_IS from '../svgs/is.svg'
import flag_IT from '../svgs/it.svg'
import flag_JE from '../svgs/je.svg'
import flag_JM from '../svgs/jm.svg'
import flag_JO from '../svgs/jo.svg'
import flag_JP from '../svgs/jp.svg'
import flag_KE from '../svgs/ke.svg'
import flag_KG from '../svgs/kg.svg'
import flag_KH from '../svgs/kh.svg'
import flag_KI from '../svgs/ki.svg'
import flag_KM from '../svgs/km.svg'
import flag_KN from '../svgs/kn.svg'
import flag_KP from '../svgs/kp.svg'
import flag_KR from '../svgs/kr.svg'
import flag_KW from '../svgs/kw.svg'
import flag_KY from '../svgs/ky.svg'
import flag_KZ from '../svgs/kz.svg'
import flag_LA from '../svgs/la.svg'
import flag_LB from '../svgs/lb.svg'
import flag_LC from '../svgs/lc.svg'
import flag_LI from '../svgs/li.svg'
import flag_LK from '../svgs/lk.svg'
import flag_LR from '../svgs/lr.svg'
import flag_LS from '../svgs/ls.svg'
import flag_LT from '../svgs/lt.svg'
import flag_LU from '../svgs/lu.svg'
import flag_LV from '../svgs/lv.svg'
import flag_LY from '../svgs/ly.svg'
import flag_MA from '../svgs/ma.svg'
import flag_MC from '../svgs/mc.svg'
import flag_MD from '../svgs/md.svg'
import flag_ME from '../svgs/me.svg'
import flag_MF from '../svgs/mf.svg'
import flag_MG from '../svgs/mg.svg'
import flag_MH from '../svgs/mh.svg'
import flag_MK from '../svgs/mk.svg'
import flag_ML from '../svgs/ml.svg'
import flag_MM from '../svgs/mm.svg'
import flag_MN from '../svgs/mn.svg'
import flag_MO from '../svgs/mo.svg'
import flag_MP from '../svgs/mp.svg'
import flag_MQ from '../svgs/mq.svg'
import flag_MR from '../svgs/mr.svg'
import flag_MS from '../svgs/ms.svg'
import flag_MT from '../svgs/mt.svg'
import flag_MU from '../svgs/mu.svg'
import flag_MV from '../svgs/mv.svg'
import flag_MW from '../svgs/mw.svg'
import flag_MX from '../svgs/mx.svg'
import flag_MY from '../svgs/my.svg'
import flag_MZ from '../svgs/mz.svg'
import flag_NA from '../svgs/na.svg'
import flag_NC from '../svgs/nc.svg'
import flag_NE from '../svgs/ne.svg'
import flag_NF from '../svgs/nf.svg'
import flag_NG from '../svgs/ng.svg'
import flag_NI from '../svgs/ni.svg'
import flag_NL from '../svgs/nl.svg'
import flag_NO from '../svgs/no.svg'
import flag_NP from '../svgs/np.svg'
import flag_NR from '../svgs/nr.svg'
import flag_NU from '../svgs/nu.svg'
import flag_NZ from '../svgs/nz.svg'
import flag_OM from '../svgs/om.svg'
import flag_PA from '../svgs/pa.svg'
import flag_PE from '../svgs/pe.svg'
import flag_PF from '../svgs/pf.svg'
import flag_PG from '../svgs/pg.svg'
import flag_PH from '../svgs/ph.svg'
import flag_PK from '../svgs/pk.svg'
import flag_PL from '../svgs/pl.svg'
import flag_PM from '../svgs/pm.svg'
import flag_PN from '../svgs/pn.svg'
import flag_PR from '../svgs/pr.svg'
import flag_PS from '../svgs/ps.svg'
import flag_PT from '../svgs/pt.svg'
import flag_PW from '../svgs/pw.svg'
import flag_PY from '../svgs/py.svg'
import flag_QA from '../svgs/qa.svg'
import flag_RE from '../svgs/re.svg'
import flag_RO from '../svgs/ro.svg'
import flag_RS from '../svgs/rs.svg'
import flag_RU from '../svgs/ru.svg'
import flag_RW from '../svgs/rw.svg'
import flag_SA from '../svgs/sa.svg'
import flag_SB from '../svgs/sb.svg'
import flag_SC from '../svgs/sc.svg'
import flag_SD from '../svgs/sd.svg'
import flag_SE from '../svgs/se.svg'
import flag_SG from '../svgs/sg.svg'
import flag_SH from '../svgs/sh.svg'
import flag_SI from '../svgs/si.svg'
import flag_SJ from '../svgs/sj.svg'
import flag_SK from '../svgs/sk.svg'
import flag_SL from '../svgs/sl.svg'
import flag_SM from '../svgs/sm.svg'
import flag_SN from '../svgs/sn.svg'
import flag_SO from '../svgs/so.svg'
import flag_SR from '../svgs/sr.svg'
import flag_SS from '../svgs/ss.svg'
import flag_ST from '../svgs/st.svg'
import flag_SV from '../svgs/sv.svg'
import flag_SX from '../svgs/sx.svg'
import flag_SY from '../svgs/sy.svg'
import flag_SZ from '../svgs/sz.svg'
import flag_TC from '../svgs/tc.svg'
import flag_TD from '../svgs/td.svg'
import flag_TF from '../svgs/tf.svg'
import flag_TG from '../svgs/tg.svg'
import flag_TH from '../svgs/th.svg'
import flag_TJ from '../svgs/tj.svg'
import flag_TK from '../svgs/tk.svg'
import flag_TL from '../svgs/tl.svg'
import flag_TM from '../svgs/tm.svg'
import flag_TN from '../svgs/tn.svg'
import flag_TO from '../svgs/to.svg'
import flag_TR from '../svgs/tr.svg'
import flag_TT from '../svgs/tt.svg'
import flag_TV from '../svgs/tv.svg'
import flag_TW from '../svgs/tw.svg'
import flag_TZ from '../svgs/tz.svg'
import flag_UA from '../svgs/ua.svg'
import flag_UG from '../svgs/ug.svg'
import flag_UM from '../svgs/um.svg'
import flag_US from '../svgs/us.svg'
import flag_UY from '../svgs/uy.svg'
import flag_UZ from '../svgs/uz.svg'
import flag_VA from '../svgs/va.svg'
import flag_VC from '../svgs/vc.svg'
import flag_VE from '../svgs/ve.svg'
import flag_VG from '../svgs/vg.svg'
import flag_VI from '../svgs/vi.svg'
import flag_VN from '../svgs/vn.svg'
import flag_VU from '../svgs/vu.svg'
import flag_WF from '../svgs/wf.svg'
import flag_XK from '../svgs/xk.svg'
import flag_WS from '../svgs/ws.svg'
import flag_YE from '../svgs/ye.svg'
import flag_YT from '../svgs/yt.svg'
import flag_ZA from '../svgs/za.svg'
import flag_ZM from '../svgs/zm.svg'
import flag_ZW from '../svgs/zw.svg'
export default {flag_AD, flag_AE, flag_AF, flag_AG, flag_AI, flag_AL, flag_AM, flag_AN, flag_AO, flag_AQ, flag_AR, flag_AS, flag_AT, flag_AU, flag_AW, flag_AX, flag_AZ, flag_BA, flag_BB, flag_BD, flag_BE, flag_BF, flag_BG, flag_BH, flag_BI, flag_BJ, flag_BL, flag_BM, flag_BN, flag_BO, flag_BQ, flag_BR, flag_BS, flag_BT, flag_BV, flag_BW, flag_BY, flag_BZ, flag_CA, flag_CC, flag_CD, flag_CF, flag_CG, flag_CH, flag_CI, flag_CK, flag_CL, flag_CM, flag_CN, flag_CO, flag_CR, flag_CU, flag_CV, flag_CW, flag_CX, flag_CY, flag_CZ, flag_DE, flag_DJ, flag_DK, flag_DM, flag_DO, flag_DZ, flag_EC, flag_EE, flag_EG, flag_EH, flag_ER, flag_ES, flag_ET, flag_EU, flag_FI, flag_FJ, flag_FK, flag_FM, flag_FO, flag_FR, flag_GA, flag_GB_ENG, flag_GB_NIR, flag_GB_SCT, flag_GB_WLS, flag_GB, flag_GD, flag_GE, flag_GF, flag_GG, flag_GH, flag_GI, flag_GL, flag_GM, flag_GN, flag_GP, flag_GQ, flag_GR, flag_GS, flag_GT, flag_GU, flag_GW, flag_GY, flag_HK, flag_HM, flag_HN, flag_HR, flag_HT, flag_HU, flag_ID, flag_IE, flag_IL, flag_IM, flag_IN, flag_IO, flag_IQ, flag_IR, flag_IS, flag_IT, flag_JE, flag_JM, flag_JO, flag_JP, flag_KE, flag_KG, flag_KH, flag_KI, flag_KM, flag_KN, flag_KP, flag_KR, flag_KW, flag_KY, flag_KZ, flag_LA, flag_LB, flag_LC, flag_LI, flag_LK, flag_LR, flag_LS, flag_LT, flag_LU, flag_LV, flag_LY, flag_MA, flag_MC, flag_MD, flag_ME, flag_MF, flag_MG, flag_MH, flag_MK, flag_ML, flag_MM, flag_MN, flag_MO, flag_MP, flag_MQ, flag_MR, flag_MS, flag_MT, flag_MU, flag_MV, flag_MW, flag_MX, flag_MY, flag_MZ, flag_NA, flag_NC, flag_NE, flag_NF, flag_NG, flag_NI, flag_NL, flag_NO, flag_NP, flag_NR, flag_NU, flag_NZ, flag_OM, flag_PA, flag_PE, flag_PF, flag_PG, flag_PH, flag_PK, flag_PL, flag_PM, flag_PN, flag_PR, flag_PS, flag_PT, flag_PW, flag_PY, flag_QA, flag_RE, flag_RO, flag_RS, flag_RU, flag_RW, flag_SA, flag_SB, flag_SC, flag_SD, flag_SE, flag_SG, flag_SH, flag_SI, flag_SJ, flag_SK, flag_SL, flag_SM, flag_SN, flag_SO, flag_SR, flag_SS, flag_ST, flag_SV, flag_SX, flag_SY, flag_SZ, flag_TC, flag_TD, flag_TF, flag_TG, flag_TH, flag_TJ, flag_TK, flag_TL, flag_TM, flag_TN, flag_TO, flag_TR, flag_TT, flag_TV, flag_TW, flag_TZ, flag_UA, flag_UG, flag_UM, flag_US, flag_UY, flag_UZ, flag_VA, flag_VC, flag_VE, flag_VG, flag_VI, flag_VN, flag_VU, flag_WF, flag_XK, flag_WS, flag_YE, flag_YT, flag_ZA, flag_ZM, flag_ZW}